export const getHealthFactor = (percentage: number | null) => {
  if (percentage === null) {
    return {
      statusColor: '',
      rangeColor: '',
      status: '',
    };
  }

  if (!isFinite(percentage)) {
    return {
      statusColor: '',
      rangeColor: '',
      status: '',
    };
  }

  if (percentage >= 201) {
    return {
      statusColor: 'text-green-100',
      rangeColor: 'bg-green-100',
      status: 'Healthy',
    };
  } else if (percentage >= 161) {
    return {
      statusColor: 'text-yellow-100',
      rangeColor: 'bg-yellow-100',
      status: 'Moderate',
    };
  } else if (percentage >= 135) {
    return {
      statusColor: 'text-red-100',
      rangeColor: 'bg-red-100',
      status: 'Risky',
    };
  } else {
    // TODO: Fix this logic later
    return {
      statusColor: '',
      rangeColor: '',
      status: '',
    };
  }
};

export const getRangecolor = (percentage: number | null | undefined) => {
  if (percentage === null || percentage === undefined) {
    return '';
  }

  if (percentage >= 201) {
    return '#59aa8a';
  } else if (percentage >= 161) {
    return '#fde37b';
  } else if (percentage >= 135) {
    return '#d04c68';
  } else {
    return '#d04c68';
  }
};

export const getFeeColor = (status: string) => {
  if (status === 'Fast') {
    return '#59aa8a';
  } else if (status === 'Medium') {
    return '#fde37b';
  } else if (status === 'Slow') {
    return '#d04c68';
  } else {
    return '#d04c68';
  }
};
